import { css } from 'linaria';

export const windowsBrandsTitle = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const windowsBrandsSelectionGroup = css`
  && {
    margin-bottom: 24px;
    width: fit-content;
  }
`;

export const windowsBrandsSelectionGroupItem = css`
  && {
    background-color: var(--background-secondary-invert);
    color: var(--text-primary-invert);

    &:hover {
      background-color: var(--control-hover-primary);
      color: var(--text-primary-invert) !important;
    }

    &[aria-pressed="true"] {
      background-color: var(--background-primary);
      color: var(--text-primary);

      &:hover {
        background-color: var(--control-minor);
        color: var(--text-primary) !important;
      }
    }
  }
`;

export const windowsBrandsGrid = css`
  display: grid;
  grid-template-columns: repeat(4, 277px);
  grid-template-rows: auto;
  gap: 24px;

  @media (--only-desktop) {
    grid-template-columns: repeat(4, 217px);
    grid-template-rows: 1fr 57px;;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 318px);
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
  }
`;

export const windowsBrandsBanner = css`
  @media (--from-desktop) {
    grid-column: 1 / 5;
  }

  @media (--only-tablet) {
    grid-column: 1 / 3;
    grid-row: 2;
  }

  @media (--only-mobile) {
    grid-row: 2;
  }
`;

export const windowsBrandsBannerImage = css`
  width: 100%;
  border-radius: var(--rounding-l);
`;

export const windowsBrandsCard = css`
  border-radius: var(--rounding-l);
  background-color: var(--background-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const windowsBrandsCardBody = css`
  padding: 24px;
  width: 100%;

  @media (--only-desktop) {
    padding: 24px 20px;
  }

  @media (--only-tablet) {
    padding: 24px 24px 32px 24px;
  }
`;

export const windowsBrandsCardImage = css`
  width: 160px;
  height: 160px;

  @media (--from-desktop) {
    margin: 24px 0;
  }

  @media (--to-desktop) {
    width: 200px;
    height: 200px;
    margin: 12px 0;
  }
`;

export const windowsBrandsCardInfo = css`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 16px;
`;

export const windowsBrandsCardProperties = css`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    column-gap: 11px;

    p {
      white-space: break-spaces;
    }
  }

  li:not(:last-child) {
    margin-bottom: 16px;
  }
`;
